import { createSlice } from "@reduxjs/toolkit";

const initialUsersRoleState = {
  entities: [],
  totalCount: 0,
  listLoading: false,
  actionsLoading: false,
  completed: false,
  message: {
    error: null,
    success: null,
  },
  warnings: [],
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const usersRoleSlice = createSlice({
  name: "roles",
  initialState: initialUsersRoleState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    endCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    // group permission fetched from api
    roleFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    roleCreated: (state, action) => {
      const { message, entity, warnings } = action.payload;
      state.actionsLoading = false;
      state.entities = [entity, ...state.entities];
      state.totalCount = state.totalCount + 1;
      state.message.success = message;
      state.warnings = warnings;
    },

    roleUpdate: (state, action) => {
      const { message, entity, warnings } = action.payload;
      state.actionsLoading = false;
      state.entities = state.entities.map((row) => (row.id === entity.id ? entity : row));
      state.message.success = message;
      state.warnings = warnings;
    },

    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },

    // searchGroupPermission: (state, action) => {
    //   state.entities = state.entities.filter((permission) => permission.key.startsWith(action.payload));
    // },
    // users changed Password
    changedPassword: (state, action) => {
      const { message } = action.payload;
      state.actionsLoading = false;
      state.message.success = message;
    },
    // users fetched from api
    userCreated: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.entities.push(entity);
      state.totalCount = state.totalCount + 1;
      state.message.success = message;
      state.completed = true;
    },
    statusChanged: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.entities = state.entities.map((row) => {
        if (row.id === entity.id) {
          row = entity;
        }
        return row;
      });
      state.message.success = message;
    },
    setStatusBack: (state, action) => {
      const { id, status } = action.payload;
      state.actionsLoading = false;
      state.entities = state.entities.map((row) => {
        if (row.id === parseInt(id)) {
          row.status = status;
        }
        return row;
      });
    },

    //change complete status
    changeCompleteStatus: (state, action) => {
      const { status } = action.payload;
      state.completed = status;
    },

    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
  },
});